import Vue from 'vue'
import Vuex from 'vuex'
import createPersiste from 'vue-savedata'
import * as actions from './actions'
import { UPDATE_SALESMAN_LIST, SET_BUCKET_DOMAIN, SET_BUCKET_DOMAIN_TOKEN } from './actionTypes';

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    permissionList: [], 
    operationList: [], //二级对应的三级操作权限列表
    imgDomain: 'https://cdn.yongxintao.com/', // 图片域名地址
    bucket_domain_token: '', //七牛上传token
    salesman_list: [], //所有的业务员
    servicelist: [], //服务项目列表
  },
  mutations: {
  	update_permisison_list(state, payload) {
      state.permissionList = payload
  	},
    update_operation_list(state, payload) {
      state.operationList = payload
    },
  	update_salesman_list(state, payload) {
      state.salesman_list = payload;
  	},
    update_servicelist(state, payload) {
      state.servicelist = payload
    },
    [SET_BUCKET_DOMAIN](state, payload) {
      state.imgDomain = payload;
    },
    [SET_BUCKET_DOMAIN_TOKEN](state, payload) {
      state.bucket_domain_token = payload;
    },
  },
  actions,
  plugins: [createPersiste()]
})

export default store;